import { Card, CardContent, Typography, Button, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSheetPlastic,
  faArrowRightToBracket,
} from '@fortawesome/free-solid-svg-icons'
import PendingBadge from './PendingBadge'

const BillingModuleCard = ({ app, onAccess, pendingCount = 0 }) => {
  return (
    <Box sx={{ width: { xs: '100%', md: '450px' }, m: 2, position: 'relative' }}>
      {/* Notificação de faturamentos pendentes de aprovação */}
      <PendingBadge count={pendingCount} moduleName={app.name} />

      <Card elevation={4} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* Header */}
        <Box
          sx={{
            background: 'linear-gradient(90deg, #0d2142 0%, #3478dd 100%)',
            color: 'white',
            textAlign: 'center',
            px: 4,
            py: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
            {app.name}
          </Typography>
          <FontAwesomeIcon icon={faSheetPlastic} size="2xl" />
        </Box>

        <CardContent
          sx={{
            bgcolor: '#f5f5f5',
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '150px',
          }}>
          <Button
            variant="contained"
            onClick={onAccess}
            startIcon={<FontAwesomeIcon icon={faArrowRightToBracket} />}
            fullWidth
            sx={{
              background: 'linear-gradient(90deg, #0d2142 0%, #3478dd 100%)',
              '&:hover': {
                filter: 'brightness(1.2)',
                transform: 'scale(1.02)',
              },
              py: 2,
              fontWeight: 'bold',
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}>
            ACESSAR FATURAMENTO
          </Button>
        </CardContent>
      </Card>
    </Box>
  )
}

export default BillingModuleCard
